import { useMutation, useQueryClient } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'

type Props = {
  itemId: string
  workflowStatusId: string
}

export function useUpdateItemStatus() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ itemId, workflowStatusId }: Props) => {
      const response = await axios.put(`items/${itemId}`, {
        workflow_status_id: workflowStatusId,
      })
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['workflow-log'])
    },
  })
}
